class MiniCart extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.header = document.querySelector('sticky-header');
    this.drawer = document.querySelector('cart-drawer');
    new IntersectionObserver(this.handleIntersection.bind(this)).observe(this);
  }

  handleIntersection(entries, observer) {
    if (!entries[0].isIntersecting) return;
    observer.unobserve(this);

    fetch(this.dataset.url)
      .then(response => response.text())
      .then(html => {
        document.getElementById('mini-cart').innerHTML =
          this.getSectionInnerHTML(html, '.shopify-section');
          
        document.dispatchEvent(new CustomEvent('cartdrawer:opened'));
      })
      .catch(e => {
        console.error(e);
      });
  }

  open() {
    const detailsElement = this.drawer.querySelector('details');
    if (detailsElement.hasAttribute('open')) {
      return;
    }
    
    this.drawer.openMenuDrawer();
    
    // Create a mutation observer to watch for changes to the DOM
    // This ensures we catch when the drawer content is fully loaded and rendered
    const observer = new MutationObserver((mutations) => {
      // Once we detect changes, try to set focus
      this.setFocusToDrawer();
      
      // Stop observing after a reasonable amount of time
      setTimeout(() => observer.disconnect(), 1000);
    });
    
    // Start observing the document body for changes
    observer.observe(document.body, { childList: true, subtree: true });
    
    // Also set focus using the cartdrawer:opened event as a trigger
    document.addEventListener('cartdrawer:opened', () => {
      this.setFocusToDrawer();
    }, { once: true });
    
    // Multiple timeouts with increasing delays as a fallback
    setTimeout(() => this.setFocusToDrawer(), 100);
    setTimeout(() => this.setFocusToDrawer(), 400);
    setTimeout(() => this.setFocusToDrawer(), 800);
  }
  
  setFocusToDrawer() {
    // Try the SVG close icon first
    const svgCloseIcon = document.querySelector('.mini-cart .icon-close');
    if (svgCloseIcon && svgCloseIcon.closest('button, .header__icon')) {
      const closeButton = svgCloseIcon.closest('button, .header__icon');
      closeButton.setAttribute('tabindex', '0');
      closeButton.focus();
      return true;
    }
    
    // Try the drawer close button
    const closeButton = document.querySelector('drawer-close-button');
    if (closeButton) {
      closeButton.setAttribute('tabindex', '0');
      closeButton.focus();
      return true;
    }
    
    // Try any focusable element in header
    const headerFocusable = document.querySelector('.mini-cart__header button, .mini-cart__header [tabindex], .mini-cart__header a');
    if (headerFocusable) {
      headerFocusable.focus();
      return true;
    }
    
    // Try any button in the mini-cart as a fallback
    const anyButton = document.querySelector('.mini-cart button');
    if (anyButton) {
      anyButton.focus();
      return true;
    }
    
    // Last resort: make the mini-cart focusable and focus it
    const miniCartElement = document.querySelector('.mini-cart, form.mini-cart');
    if (miniCartElement) {
      miniCartElement.setAttribute('tabindex', '0');
      miniCartElement.focus();
      return true;
    }
    
    return false;
  }

  renderContents(parsedState) {
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section => {
      if (document.getElementById(section.id)) {
        document.getElementById(section.id).innerHTML =
          this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
      }
    }));

    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'mini-cart',
        section: 'mini-cart',
        selector: '.shopify-section'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'mobile-cart-icon-bubble',
        section: 'mobile-cart-icon-bubble',
        selector: '.shopify-section'
      }
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('mini-cart', MiniCart);
